import { useCallback, useEffect, useState } from "react";
import { useDeptEmployees } from "../services";
import { useDebounceCallback } from "usehooks-ts";

export function useUserSearch(initSearchValue?: string) {
  const [searchValue, setSearchValue] = useState("");
  const debouncedSetSearchValue = useDebounceCallback(setSearchValue, 500);
  const { employeeList } = useDeptEmployees({ searchValue });
  const options = employeeList.map((e) => ({
    label: e.nickName,
    value: e.userName,
    raw: e,
  }));

  const userIdOptions = employeeList.map((e) => ({
    label: e.nickName,
    value: e.id,
    raw: e,
  }));

  const handleSearch = useCallback(
    (searchValue: string) => {
      debouncedSetSearchValue(searchValue);
    },
    [debouncedSetSearchValue],
  );

  useEffect(() => {
    // Auto-search on first load
    handleSearch("");
  }, [handleSearch]);

  useEffect(() => {
    if (initSearchValue) {
      handleSearch(initSearchValue);
    }
  }, [initSearchValue, handleSearch]);

  return {
    handleSearch,
    options,
    userIdOptions,
  };
}
